var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { OnInit, OnDestroy } from '@angular/core';
import { Select, Store, Actions, ofActionDispatched } from '@ngxs/store';
import { BookmarksState } from 'src/app/bookmarks/state/bookmarks.state';
import { Observable, Subject } from 'rxjs';
import { LoadBookmarks, SortBookmarks, CheckBookmark, SetCheckedBookmarks, ExportBookmarks, ExportBookmarksSuccess, ExportBookmarksError, LoadOrganizationBookmarks, LoadCollectionBookmarks, SetSelectedCategory, ClearBookmarks } from 'src/app/bookmarks/state/bookmarks.actions';
import { SetTheme } from 'src/app/layout/state/layout.actions';
import { LayoutThemeEnum } from 'src/app/layout/models/layout-theme.enum';
import { SelectOrganization, SelectCollection, GetCollections } from 'src/app/organizations/state/organizations.actions';
import { OrganizationsState } from 'src/app/organizations/state/organizations.state';
import { PublishDialogComponent } from 'src/app/publish/components/publish-dialog/publish-dialog.component';
import { MatDialog, MatSnackBar } from '@angular/material';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { BookmarksService } from 'src/app/bookmarks/bookmarks.service';
import { BookmarkActionsEnum } from 'src/app/bookmarks/components/bookmark-actions/bookmark-actions.component';
import { WidgetOptions } from 'src/app/publish/models/widget-options.model';
import { PublishState } from 'src/app/publish/state/publish.state';
import { PublishService } from 'src/app/publish/publish.service';
import { takeUntil, filter, take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { GalleryState } from 'src/app/gallery/state/gallery.state';
import { GalleryViewMode } from 'src/app/gallery/models/gallery-view-mode.enum';
var DashboardComponent = /** @class */ (function () {
    function DashboardComponent(store, dialog, bookmarksService, publishService, actions, snackBar, router) {
        this.store = store;
        this.dialog = dialog;
        this.bookmarksService = bookmarksService;
        this.publishService = publishService;
        this.actions = actions;
        this.snackBar = snackBar;
        this.router = router;
        this.ngUnsubscribe = new Subject();
        this.renderCardCount = 0;
        this.galleryViewMode = GalleryViewMode;
    }
    Object.defineProperty(DashboardComponent.prototype, "isEmpty", {
        get: function () {
            var isLoading = this.store.selectSnapshot(BookmarksState.getLoading);
            var bookmarks = this.store.selectSnapshot(BookmarksState.getBookmarks);
            return !isLoading && bookmarks.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardComponent.prototype, "userSelectionLabel", {
        /**
         * Gets computed selection label
         */
        get: function () {
            var selectedOrganization = this.store.selectSnapshot(OrganizationsState.getSelectedOrganization);
            var selectedCollection = this.store.selectSnapshot(OrganizationsState.getSelectedCollection);
            var collections = this.store.selectSnapshot(OrganizationsState.getCollections);
            if (selectedOrganization) {
                if (selectedCollection) {
                    return "Team Models - " + selectedCollection.collection_name;
                }
                else {
                    return collections && collections.length ? 'Team Models - All' : 'Team Models';
                }
            }
            else {
                return 'My Models';
            }
        },
        enumerable: true,
        configurable: true
    });
    DashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.store.dispatch(new SetTheme(LayoutThemeEnum.Light)); // #FIXME: Better theme toggling
        // set initial user selection
        this.initUserSelection();
        // handle export actions
        this.actions
            .pipe(ofActionDispatched(ExportBookmarksSuccess), takeUntil(this.ngUnsubscribe))
            .subscribe(function (response) {
            _this.clearSelection();
            _this.snackBar.open("Successfully exported " + response.bookmarks.length + " bookmarks.");
        });
        this.actions
            .pipe(ofActionDispatched(ExportBookmarksError), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.snackBar.open("Error exporting selected bookmarks.");
        });
    };
    DashboardComponent.prototype.ngOnDestroy = function () {
        this.store.dispatch(new ClearBookmarks());
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    DashboardComponent.prototype.initUserSelection = function () {
        var _this = this;
        // set selected category
        this.actions
            .pipe(ofActionDispatched(LoadBookmarks, LoadOrganizationBookmarks, LoadCollectionBookmarks), takeUntil(this.ngUnsubscribe))
            .subscribe(function (e) {
            if (e instanceof LoadOrganizationBookmarks) {
                _this.store.dispatch(new SetSelectedCategory('organization'));
            }
            else if (e instanceof LoadCollectionBookmarks) {
                _this.store.dispatch(new SetSelectedCategory('collection'));
            }
            else {
                _this.store.dispatch(new SetSelectedCategory('individual'));
            }
        });
        // populate collections
        this.organization$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (organization) {
            if (organization) {
                _this.store.dispatch(new GetCollections(organization.id));
            }
        });
        // wait for organization: set selection
        this.organizations$
            .pipe(filter(function (organizations) { return !!organizations; }), take(1), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            var selectedCategory = _this.store.selectSnapshot(BookmarksState.getSelectedCategory);
            var organization = _this.store.selectSnapshot(OrganizationsState.getOrganization);
            var selectedOrganization = _this.store.selectSnapshot(OrganizationsState.getSelectedOrganization);
            var selectedCollection = _this.store.selectSnapshot(OrganizationsState.getSelectedCollection);
            if (selectedCategory === 'collection' && selectedCollection) { // persist collection
                _this.selectCollection(selectedCollection);
            }
            else if (selectedCategory === 'organization' && selectedOrganization) { // persist organization
                _this.selectOrganization(selectedOrganization);
            }
            else { // default selection
                if (organization && selectedCategory !== 'individual') {
                    _this.selectOrganization(organization);
                }
                else {
                    _this.selectPrivate();
                }
            }
        });
    };
    DashboardComponent.prototype.handleRenderCountChange = function (count) {
        this.renderCardCount = count;
    };
    DashboardComponent.prototype.handleBookmarksSort = function (sort) {
        this.sort(sort);
    };
    DashboardComponent.prototype.handleCheckedChange = function (ids) {
        this.store.dispatch(new SetCheckedBookmarks(ids));
    };
    DashboardComponent.prototype.handleSelectBookmark = function (bookmark) {
        var isCustomWidget = this.isCustomWidget(bookmark);
        if (bookmark.unavailable) { // notify unavailable
            this.viewUnavailableMessage(bookmark);
        }
        else if (isCustomWidget) { // view in tab
            var url = this.publishService.getWidgetURL(bookmark, bookmark.embed_url, new WidgetOptions());
            this.viewInNewTab(url, bookmark.title);
        }
        else { // view bookmark
            this.viewBookmark(bookmark);
        }
    };
    DashboardComponent.prototype.handleSelectPrivate = function () {
        this.selectPrivate();
    };
    DashboardComponent.prototype.handleSelectOrganization = function (organization) {
        this.selectOrganization(organization);
    };
    DashboardComponent.prototype.handleSelectCollection = function (collection) {
        this.selectCollection(collection);
    };
    DashboardComponent.prototype.selectPrivate = function () {
        this.store.dispatch(new SelectOrganization(null));
        this.store.dispatch(new LoadBookmarks(''));
    };
    DashboardComponent.prototype.selectOrganization = function (organization) {
        this.store.dispatch(new SelectOrganization(organization));
        this.store.dispatch(new SelectCollection(null));
        this.store.dispatch(new LoadOrganizationBookmarks(organization.id));
    };
    DashboardComponent.prototype.selectCollection = function (collection) {
        this.store.dispatch(new SelectCollection(collection));
        this.store.dispatch(new LoadCollectionBookmarks(collection.group_id, collection.collection_id));
    };
    DashboardComponent.prototype.getBookmarkActions = function (bookmark) {
        var isCustomWidget = this.isCustomWidget(bookmark);
        var canEdit = this.canEdit(bookmark);
        var bookmarkActions = [
            BookmarkActionsEnum.CopyLink,
            BookmarkActionsEnum.Embed
        ];
        if (!isCustomWidget) {
            bookmarkActions = __spread(bookmarkActions, [
                BookmarkActionsEnum.View,
                BookmarkActionsEnum.Edit,
                BookmarkActionsEnum.CopyBookmark
            ]);
        }
        if (canEdit) {
            bookmarkActions = __spread(bookmarkActions, [
                BookmarkActionsEnum.Manage,
                BookmarkActionsEnum.Delete
            ]);
        }
        else if (bookmark.favorite) { // enable deleting favorites
            bookmarkActions = __spread(bookmarkActions, [
                BookmarkActionsEnum.Delete
            ]);
        }
        // special case: delete orphaned records
        if (bookmark.unavailable) {
            bookmarkActions = [
                BookmarkActionsEnum.Delete
            ];
        }
        return bookmarkActions;
    };
    DashboardComponent.prototype.sort = function (sort) {
        this.store.dispatch(new SortBookmarks(sort));
    };
    DashboardComponent.prototype.handleEmbedModel = function (bookmark) {
        var dialogRef = this.dialog.open(PublishDialogComponent, {
            width: '90vw',
            data: {
                bookmark: bookmark
            }
        });
        dialogRef.afterClosed().subscribe(function (result) {
        });
    };
    DashboardComponent.prototype.handleCheckChanged = function (checked, id) {
        this.setChecked(checked, id);
    };
    DashboardComponent.prototype.setChecked = function (checked, id) {
        this.store.dispatch(new CheckBookmark(id, checked));
    };
    DashboardComponent.prototype.isChecked = function (id) {
        return this.store.selectSnapshot(BookmarksState.getCheckedBookmarks)
            .some(function (bookmarkId) { return bookmarkId === id; });
    };
    DashboardComponent.prototype.canEdit = function (bookmark) {
        return this.bookmarksService.canEdit(bookmark);
    };
    DashboardComponent.prototype.handleSelectAllClick = function () {
        this.selectAll();
    };
    DashboardComponent.prototype.handleClearSelectionClick = function () {
        this.clearSelection();
    };
    DashboardComponent.prototype.handleExportSelectionClick = function () {
        this.exportSelected();
    };
    DashboardComponent.prototype.exportSelected = function () {
        var bookmarks = this.store.selectSnapshot(BookmarksState.getBookmarks);
        var checkedBookmarks = this.store.selectSnapshot(BookmarksState.getCheckedBookmarks);
        var exportBookmarks = bookmarks
            .filter(function (bookmark) { return checkedBookmarks.some(function (id) { return bookmark.id === id; }); });
        // set export options
        var widgetURL = this.store.selectSnapshot(PublishState.getWidgetURL);
        var widgetOptions = this.store.selectSnapshot(OrganizationsState.getWidgetOptions);
        var appFeatures = this.store.selectSnapshot(OrganizationsState.getAppFeatures);
        var offlineEnabled = appFeatures && appFeatures.offlinePkgGen;
        this.store.dispatch(new ExportBookmarks(exportBookmarks, widgetURL, widgetOptions, offlineEnabled));
    };
    DashboardComponent.prototype.selectAll = function () {
        var ids = this.store.selectSnapshot(BookmarksState.getBookmarks)
            .map(function (bookmark) { return bookmark.id; });
        this.store.dispatch(new SetCheckedBookmarks(ids));
    };
    DashboardComponent.prototype.clearSelection = function () {
        this.store.dispatch(new SetCheckedBookmarks([]));
    };
    DashboardComponent.prototype.isCustomWidget = function (bookmark) {
        return this.publishService.isCustomWidget(bookmark.embed_url_path);
    };
    DashboardComponent.prototype.viewBookmark = function (bookmark) {
        var id = bookmark.id, type = bookmark.type;
        this.router.navigate(['/view'], { queryParams: { id: id, type: type } });
    };
    DashboardComponent.prototype.viewInNewTab = function (url, title) {
        var handle = window.open(url);
        if (handle) {
            this.snackBar.open("\"" + title + "\" loaded in a new tab.");
        }
        else {
            this.snackBar.open("Error launching \"" + title + "\" in a new tab.");
        }
    };
    // #TODO[AC]: handle removing unavilable content
    DashboardComponent.prototype.viewUnavailableMessage = function (bookmark) {
    };
    DashboardComponent.prototype.trackBookmark = function (bookmark) {
        return bookmark.id;
    };
    __decorate([
        Select(BookmarksState.getBookmarks),
        __metadata("design:type", Observable)
    ], DashboardComponent.prototype, "bookmarks$", void 0);
    __decorate([
        Select(BookmarksState.getCheckedBookmarks),
        __metadata("design:type", Observable)
    ], DashboardComponent.prototype, "checkedBookmarks$", void 0);
    __decorate([
        Select(BookmarksState.getLoading),
        __metadata("design:type", Observable)
    ], DashboardComponent.prototype, "loading$", void 0);
    __decorate([
        Select(BookmarksState.getExporting),
        __metadata("design:type", Observable)
    ], DashboardComponent.prototype, "exporting$", void 0);
    __decorate([
        Select(BookmarksState.getSort),
        __metadata("design:type", Observable)
    ], DashboardComponent.prototype, "sort$", void 0);
    __decorate([
        Select(OrganizationsState.getOrganization),
        __metadata("design:type", Observable)
    ], DashboardComponent.prototype, "organization$", void 0);
    __decorate([
        Select(OrganizationsState.getOrganizations),
        __metadata("design:type", Observable)
    ], DashboardComponent.prototype, "organizations$", void 0);
    __decorate([
        Select(OrganizationsState.getSelectedOrganization),
        __metadata("design:type", Observable)
    ], DashboardComponent.prototype, "selectedOrganization$", void 0);
    __decorate([
        Select(OrganizationsState.getCollections),
        __metadata("design:type", Observable)
    ], DashboardComponent.prototype, "collections$", void 0);
    __decorate([
        Select(OrganizationsState.getSelectedCollection),
        __metadata("design:type", Observable)
    ], DashboardComponent.prototype, "selectedCollection$", void 0);
    __decorate([
        Select(AuthState.getUserProfile),
        __metadata("design:type", Observable)
    ], DashboardComponent.prototype, "userProfile$", void 0);
    __decorate([
        Select(GalleryState.getViewMode),
        __metadata("design:type", Observable)
    ], DashboardComponent.prototype, "viewMode$", void 0);
    return DashboardComponent;
}());
export { DashboardComponent };
